import * as React from "react";
import {message, Button} from "antd";
import {observer} from "mobx-react";
import mail from "../../assets/image/mail.svg";
import {RouteComponentProps} from "react-router";
import {getCurrentLan} from "@netless/i18n-react-router";
import {injectIntl, InjectedIntlProps, FormattedMessage} from "react-intl";
import "./Register.less";
import LoginLayout from "../LoginLayout";
import {consoleApi} from "../../apiMiddleware";
import {ResPutData} from "../../models/LoginStore";

export type RegisterProps = RouteComponentProps<{tab: string}> & InjectedIntlProps;

@observer
class EmailAccountVerificationStepTwo extends React.Component<RegisterProps, {}> {

    public constructor(props: RegisterProps) {
        super(props);
    }

    private sendMail = async (): Promise<void> => {
        const {intl} = this.props;
        const email = this.props.match.params.tab;
        try {
            const res: ResPutData = await consoleApi.user.loginResetPassword(email);
            if (res.code === 200) {
                message.success(intl.formatMessage({id: "send-email-success"}));
                this.setState({isSend: true});
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    private goToEmailLogin = (): string => {
        const mail = this.props.match.params.tab;
        if (mail) {
            const hash = {
                "qq.com": "https://mail.qq.com",
                "gmail.com": "https://mail.google.com",
                "sina.com": "https://mail.sina.com.cn",
                "163.com": "https://mail.163.com",
                "126.com": "https://mail.126.com",
                "yeah.net": "https://www.yeah.net/",
                "sohu.com": "https://mail.sohu.com/",
                "tom.com": "https://mail.tom.com/",
                "sogou.com": "https://mail.sogou.com/",
                "139.com": "https://mail.10086.cn/",
                "hotmail.com": "https://www.hotmail.com",
                "live.com": "https://login.live.com/",
                "live.cn": "https://login.live.cn/",
                "live.com.cn": "https://login.live.com.cn",
                "189.com": "https://webmail16.189.cn/webmail/",
                "yahoo.com.cn": "https://mail.cn.yahoo.com/",
                "yahoo.cn": "https://mail.cn.yahoo.com/",
                "eyou.com": "https://www.eyou.com/",
                "21cn.com": "https://mail.21cn.com/",
                "188.com": "https://www.188.com/",
                "foxmail.com": "https://www.foxmail.com",
                "outlook.com": "https://www.outlook.com",
            };
            const _email = mail.split("@")[1];
            if (hash.hasOwnProperty(_email)) {
                return (hash as any)[_email];
            } else {
                return `https://${_email}`;
            }
        } else {
            if (process.env.REGION === "cn") {
                return "https://mail.qq.com";
            } else {
                return "https://mail.google.com";
            }
        }
    }

    private renderTips(): string {
        const isEnglish: boolean = getCurrentLan() === "en";
        if (isEnglish) {
            return `Account reactivation email sent to ${this.props.match.params.tab}`;
        } else {
            return `已向 ${this.props.match.params.tab} 发送账号重新激活邮件`;
        }
    }

    public render(): React.ReactNode {
        return (
            <LoginLayout>
                <div className="recharge-box-two">
                    <img className="recharge-box-two-icon" src={mail} alt={"mail"}/>
                    <div className="recharge-box-two-title">
                        <FormattedMessage
                            id={"email-verify.verify-account"}
                        />
                    </div>
                    <div className="recharge-box-two-script">
                        {this.renderTips()}<br/>
                        <FormattedMessage
                            id={"email-verify.account-activation-tips"}
                        />
                    </div>
                    <a href={this.goToEmailLogin()} target="_blank">
                        <Button
                            size="large"
                            type="primary"
                            className="recharge-box-two-btn"
                        >
                            <FormattedMessage
                                id={"email-verify.go-to-verification"}
                            />
                        </Button>
                    </a>
                    <span
                        onClick={this.sendMail}
                        className="recharge-box-two-push">
                        <FormattedMessage
                            id={"email-verify.resend-email"}
                        />
                    </span>
                    <div className="recharge-box-two-under">
                        <FormattedMessage
                            id={"email-verify.resend-email-tips"}
                        />
                    </div>
                </div>
            </LoginLayout>
        );
    }
}

export default injectIntl(EmailAccountVerificationStepTwo);



// WEBPACK FOOTER //
// ./src/components/user/EmailAccountVerificationStepTwo.tsx